( function( global, $ ) {
    "use strict";

    var _events = {
        onChangePaidAtFilter: function() {
            var $paidAtFilterInput = $(this),
                $formEntry = $('[data-form-entry="tour_agent_payment"]'),
                $paidAtInput = $formEntry.find('[data-form-control="paid_at"]').first(),
                $paidAtFilterValue = $paidAtFilterInput.val();

            $paidAtInput.val($paidAtFilterValue);
        },

        onChangeNoteFilter: function() {
            var $noteFilterInput = $(this),
                $formEntry = $('[data-form-entry="tour_agent_payment"]'),
                $noteInput = $formEntry.find('[data-form-control="note"]').first(),
                $noteFilterValue = $noteFilterInput.val();

            $noteInput.val($noteFilterValue);
        },

        onChangeCommission: function() {
            var $commissionInput = $(this),
                $formEntry = $commissionInput.closest('form[data-form-entry="tour_agent_payment"]'),
                $total = $formEntry.find('[data-form-control="total"]').first(),
                $formFilter = $('[data-form-entry="tour_agent_payment_filter"]'),
                $totalHeader = $formFilter.find('[data-form-control="total"]');

            if ($commissionInput.prop('checked')) {
                $total.data('value', $total.data('value') + $commissionInput.data('value'));
            } else {
                $total.data('value', $total.data('value') - $commissionInput.data('value'));
            }

            // format currency
            // TODO how to fetch the currency and locale from laravel config ?
            var formatter = new Intl.NumberFormat('fr-CA', {
                style : 'currency',
                currency : 'CAD'
            });

            $total.html(formatter.format($total.data('value')));
            $totalHeader.html(formatter.format($total.data('value')));

            _events.refreshPaymentButton($commissionInput);
        },

        onChangeAllCommissions: function() {
            var $allCommissionsInput = $(this),
                $formEntry = $allCommissionsInput.closest('form[data-form-entry="tour_agent_payment"]'),
                $commissionInputs = $formEntry.find('[data-form-control="commission"]');

            $commissionInputs.each(function ($index, $commissionInput) {
                if ($allCommissionsInput.prop('checked')) {
                    if (!$($commissionInput).prop('checked')) {
                        $($commissionInput).trigger('click');
                    }
                } else {
                    if ($($commissionInput).prop('checked')) {
                        $($commissionInput).trigger('click');
                    }
                }
            });
        },

        refreshPaymentButton: function($commissionInput) {
            var $formEntry = $commissionInput.closest('form[data-form-entry="tour_agent_payment"]'),
                $commissionInputsEnabled = $formEntry.find('[data-form-control="commission"]:checked'),
                $paymentButton = $formEntry.find('[data-form-control="tour_agent_payment_button"]');

            $commissionInputsEnabled.length
                ? $paymentButton.removeClass('ghost').prop('disabled', false)
                : $paymentButton.addClass('ghost').prop('disabled', true)
            ;
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formFilterEntries = $container.find('[data-form-entry="tour_agent_payment_filter"]'),
            $paidAtFilterInput = $formFilterEntries.find('[data-form-control="paid_at"]').first(),
            $noteFilterInput = $formFilterEntries.find('[data-form-control="note"]').first(),
            $formEntries = $container.find('[data-form-entry="tour_agent_payment"]'),
            $commissionEntries = $formEntries.find('[data-form-control="commission"]'),
            $allCommissionsInput = $formEntries.find('#tour_agent_payment_all_commissions');

        $paidAtFilterInput.on('change', _events.onChangePaidAtFilter);
        $noteFilterInput.on('change', _events.onChangeNoteFilter);
        $commissionEntries.on('change', _events.onChangeCommission);
        $allCommissionsInput.on('change', _events.onChangeAllCommissions);
    });

}( window.groots, jQuery ));
